<template>
  <AppIconDelete @click="deleteSimulation" />
</template>

<script>
import { mapActions } from 'vuex'
import { SimulationPlanRepository } from '@/models/Simulation'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'ButtonDelete',
  props: {
    simulationPlan: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async deleteSimulation() {
      const agreed = await this.$confirm('シミュレーション削除', {
        body: this.createMessage(),
      })
      if (!agreed) {
        return false
      }

      try {
        await SimulationPlanRepository.delete(this.simulationPlan.id)
        this.$emit('onDeleted')
        this.showSuccessSnackbar()
      } catch (e) {
        this.showErrorSnackbar()
      }
    },
    createMessage() {
      if (!this.simulationPlan.isRunning)
        return `${this.simulationPlan.name}を削除してもよろしいですか？<br /> ※ シミュレーションは削除されますが、シミュレーション完了後に結果がメールで送付されます。`
      return `${this.simulationPlan.name}を削除してもよろしいですか？`
    },
    showSuccessSnackbar() {
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: 'シミュレーションを削除しました',
      })
    },
    showErrorSnackbar() {
      this.showSnackbar({
        type: snackbarType.ERROR,
        message: 'シミュレーションの削除に失敗しました',
      })
    },
  },
}
</script>

<style scoped></style>
